import { Injectable } from '@angular/core';

@Injectable()
export class JwtService {
    getToken(): string {
        return window.localStorage.getItem('token')
    }

    saveToken(token: string) {
        window.localStorage.setItem('token', token);
    }

    destroyToken() {
        window.localStorage.clear();
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/jwt.service.ts